import { axios } from 'cm'
import { debounce } from '../../libs/utils'
import './style.scss'

/**
 * M站首页吸顶
 * @type {{el: HTMLElement, link: {appLink: string, personalLink: string, infoLink: string, searchLink: string}, messageNum: number, mode: string}}
 */

let configs = {
  el: document.body,
  link: {
    appLink: '//a.app.qq.com/o/simple.jsp?pkgname=com.xinli.yixinli',
    personalLink: '//m.xinli001.com/user',
    infoLink: '//m.xinli001.com/user',
    searchLink: '//static.xinli001.com/msite/index.html#/search',
    avatarLink: ''
  },
  messageNum: 0,
  mode: 'before'
}

export default class {
  constructor(options = configs) {
    this.$el = options.el
    this.mode = options.mode
    this.messageNum = options.messageNum
    this.link = options.link
    this.isLogin = !!options.link.avatarLink //如果有头像链接即已登录
    this.hideGoTop = options.hideGoTop
    this.scrollHeight = options.scrollHeight
    this.$root = this.$el.querySelector('.fixed-header')
    if (!this.$el || !(this.$el instanceof Node)) {
      throw Error('header.js => el is not a Node!')
    }
    this.init()
  }

  init() {
    this.render()
    this.renderMenu()
    setTimeout(() => {
      this.eventInit()
    }, 50)
  }

  render() {
    let $el = this.$el
    let $root = document.createElement('div')
    let $link = this.link
    let $messageNum = this.messageNum
    let $iconLink =
      $link.avatarLink ||
      '//a.app.qq.com/o/simple.jsp?pkgname=com.xinli.yixinli'

    $root.className = 'fixed-header'
    $root.innerHTML = ` <div class="header-list">
                                ${
                                  this.isLogin
                                    ? `<a class="head-link" href="${$link.personalLink}">
                                    <img src="${this.link.avatarLink}" class="avatar"/>
                                   </a>`
                                    : `<a href="${$iconLink}" class="downloadApp head-link"></a>`
                                }
                                
                                ${
                                  this.hideGoTop
                                    ? ''
                                    : `<a id="goTop">回到顶部</a>`
                                }
                                
                                <a href="${
                                  $link.personalLink
                                }" id="personal">个人中心</a>
                                <a href="${
                                  $link.infoLink
                                }" id="information">消息${
      $messageNum > 0 ? '(' + $messageNum + ')' : ''
    }</a>
                            </div>
                            <a href="${
                              $link.searchLink
                            }" class="yxl-font yxl-font-search"></a>
                            <a class="yxl-menu">
                              <img src="${require('./icon-menu.png')}" />
                            </a>
                            `

    if (this.mode === 'replace') {
      $el.parentNode.replaceChild($root, $el)
    } else if (this.mode === 'after') {
      $el.appendChild($root)
    } else {
      $el.insertBefore($root, $el.firstChild)
    }
    this.$root = $root
    console.log('$root', $root)
  }

  renderMenu() {
    const menus = [
      {
        title: '心理咨询',
        url: 'https://m.xinli001.com/consult?channel_flag=shouye'
      },
      {
        title: '即时倾诉',
        url: 'https://m.xinli001.com/qingsu?channel_flag=shouye'
      },
      {
        title: '文章阅读',
        url: 'https://m.xinli001.com/article/index'
      },
      {
        title: '心事问答',
        url: 'https://m.xinli001.com/qa?from=shouye-dh'
      },
      {
        title: '心理课程',
        url: 'https://m.xinli001.com/lessonIndex?from=shouye-dh'
      },
      {
        title: '心理测试',
        url: 'https://m.xinli001.com/ceshi?from=shouye-dh'
      },
      {
        title: '品牌公益',
        url: 'https://www.xinli001.com/community'
      }
    ]
    const $tpl = `
      <div class="header-menu">
        <div class="menu-mask"></div>
        <div class="menu-content">
          ${menus
            .map(menu => {
              return `
                <a class="menu-item" href="${menu.url}">
                  ${menu.title}
                </a>
              `
            })
            .join('')}
        </div>
      </div>
    `
    document.body.insertAdjacentHTML('beforeend', $tpl)
  }

  eventInit() {
    this.scrollEvent()
    this.toTopEvent()
    this.menuEvent()
  }

  menuEvent() {
    if (!window.yxl) {
      window.yxl = {}
    }
    window.yxl.mobileIndexMenuHandler = () => {
      setTimeout(() => {
        const el = document.querySelector('.header-menu')
        el.style.top = this.$root.offsetHeight + 'px'
      }, 50)
    }

    const menuIcon = document.querySelector('.yxl-menu')

    const openMenu = () => {
      const el = document.querySelector('.header-menu')
      el.style.display = 'block'
      el.style.top = this.$root.offsetHeight + 'px'
      setTimeout(() => {
        document
          .querySelector('.header-menu .menu-content')
          .classList.add('active')
      }, 50)
    }
    const closeMenu = () => {
      document
        .querySelector('.header-menu .menu-content')
        .classList.remove('active')
      setTimeout(() => {
        document.querySelector('.header-menu').style.display = 'none'
      }, 400)
    }

    menuIcon.addEventListener('click', () => {
      const el = document.querySelector('.header-menu')
      if (el.offsetWidth > 0) {
        closeMenu()
      } else {
        openMenu()
      }
    })

    const menuMask = document.querySelector('.header-menu .menu-mask')
    menuMask.addEventListener('click', () => {
      closeMenu()
    })
  }

  toTopEvent() {
    let $target = this.$root.querySelector('#goTop')
    if (!$target) return
    function goToTop() {
      let $scrollTop =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.scrollY
      let speed = 1.2
      window.scrollTo(0, Math.floor($scrollTop / speed))
      if ($scrollTop > 0) {
        requestAnimationFrame(goToTop)
      }
    }

    $target.addEventListener('click', goToTop)
  }

  scrollEvent() {
    let $root = this.$root
    console.log('scrollHeight', this.scrollHeight)
    let scrollFun = debounce(() => {
      let $wScrollY =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.scrollY
      if ($wScrollY > this.scrollHeight) {
        $root.classList.add('active')
      } else {
        $root.classList.remove('active')
      }
    }, 20)
    window.addEventListener('scroll', scrollFun)
  }
}



// WEBPACK FOOTER //
// ./src/public-resource/components/FixHeader/FixHeader.js